import React, { Component } from "react";
import { NavLink as Link } from "react-router-dom";
import NavbarLink, { NavbarButton } from "../../NavigationLink";
import { saveLinks } from "../../../../../actions/contentActions";
import { startFetch, endFetch } from "../../../../../actions/generalActions";
import NavigationSubNavbarLink, {
  SubNavbarButton,
} from "../../NavigationSubNavbarLink";
import { connect } from "react-redux";
import NotificationList from "../../Notifications/index";
import Counter from "../../Counter";
import Burger from "../../Burger";
import Dropdown from "./ElipsisDropdown";
import UserBadge from "./UserBadge";
import {
  UserService,
  AuthenticationService,
  doLogout,
  selectCampaign,
  ShoppingCartIcon,
  User01,
  substring,
  ChevronDown,
  CloseMD,
} from "../../../normalizer";
import { headerLinksService } from "../../../../../services";
import SimpleDropdown from "../../../shared/SimpleDropDown";
import HeadersSection from "./HeadersSection";
import { HoverButton } from "../../../shared/HoverButton";
import ReactGA from "react-ga";
import { withRouter } from "react-router-dom";
import { t } from "../../../../../i18n";
import KeyDropdownValue from "../../KeyDropdownValue";

class NavBar extends Component {
  state = {
    toggled: false,
    Component: NavbarLink,
    ButtonComponent: NavbarButton,
  };
  mobileClassesToAdd = ["gl-nav--active", "bg-white", "text-color"];
  mobileClassesToRemove = ["navbar-text"];

  stickNavbar = () => {
    const classes = ["gl-navbar--scrolling"];

    const currentPosition = window.pageYOffset;
    const navbar = document.getElementById("g-navbar");

    if (currentPosition > navbar.offsetHeight + navbar.offsetTop) {
      classes.forEach((c) => {
        navbar.classList.add(c);
      });
    } else {
      classes.forEach((c) => {
        navbar.classList.remove(c);
      });
    }
  };

  handleLogout = () => {
    UserService.logOut().then((response) => {
      AuthenticationService.logout();
      this.props.selectCampaign(undefined);
      this.props.doLogOut();
    });
  };

  hideMenu = () => {
    this.setState({ toggled: false });
  };

  showMenu = () => {
    this.setState({ toggled: true });
  };

  // 1280px = $bp-small-desktop. Matches the SCSS @include below-small-desktop
  // block in _navbar.scss that hides .gl-navbar-links / .gl-navbar-header__menu
  // and shows .gl-burger. Keep these two thresholds aligned to avoid mid-state
  // UI (drawer-mode JSX with desktop-mode CSS or vice versa).
  //
  // Why 1280 instead of 740: a Lenovo Tab M10 Plus (Gen 3) in portrait reports
  // window.innerWidth = 800px (DPR 1.5×, physical 1200px). At 740 it was
  // treated as desktop and the full 3-row nav was crammed into 800px causing
  // all four reported navbar interaction failures. The drawer is now activated
  // for the entire 740–1279px range (tablet-only) and landscape (1333px) still
  // gets the full desktop nav.
  updateSizes = () => {
    const isDesktop = window.innerWidth >= 1280;
    if (isDesktop) this.hideMenu();

    this.setState({
      Component: isDesktop ? NavbarLink : NavigationSubNavbarLink,
      ButtonComponent: isDesktop ? NavbarButton : SubNavbarButton,
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateSizes);
    this.updateSizes();
    window.onscroll = this.stickNavbar;
    this.getHeaderLinks();
  }

  getHeaderLinks() {
    this.props.startFetch();
    const { user, campaign } = this.props;
    const payload = { clientId: user.client.slug, campaignSlug: campaign.slug };
    headerLinksService
      .getLinks(payload)
      .then((response) => response.data.header_links)
      .then((links) => {
        this.props.saveLinks({ header_links: links });
        this.props.endFetch();
      })
      .catch((error) => {
        this.props.endFetch();
      });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateSizes);
    window.onscroll = undefined;
  }

  customNavbar(campaign, type) {
    if (campaign.custom_navitems === undefined) {
      return {};
    }
    if (campaign.custom_navitems.length === 0) {
      return {};
    }
    const selectedItem = campaign.custom_navitems.find(
      (navitem) => navitem.navitem_type === type,
    );
    return selectedItem || {};
  }

  customizeNavBar = () => {
    const { toRender, campaign } = this.props;

    const dashboardWillRender = toRender("Dashboard") !== undefined;
    const showAcceleratorsTab =
      campaign.options.hide_accelerators_tab == null ||
      !campaign.options.hide_accelerators_tab;

    const defaultNavbar = [
      {
        willRender: toRender("News") !== undefined,
        props: { to: "/news", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "news").navitem_label ||
          t("gamification2026.navbar.news"),
        order: this.customNavbar(campaign, "news").navitem_order || 10001,
        type: "news",
      },
      {
        willRender: toRender("Quizzes") !== undefined,
        props: { to: "/quiz", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "quizzes").navitem_label ||
          t("gamification2026.navbar.quizzes"),
        order: this.customNavbar(campaign, "quizzes").navitem_order || 10002,
        type: "quizzes",
      },
      {
        willRender: dashboardWillRender
          ? false
          : toRender("Gamification-Objetivos") !== undefined,
        props: { to: "/objectives", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "objectives").navitem_label ||
          t("gamification2026.navbar.results"),
        order: this.customNavbar(campaign, "objectives").navitem_order || 10003,
        type: "objectives",
      },
      {
        willRender: dashboardWillRender
          ? false
          : toRender("Rankings") !== undefined,
        props: { to: "/rankings", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "rankings").navitem_label ||
          t("gamification2026.navbar.rankings"),
        order: this.customNavbar(campaign, "rankings").navitem_order || 10004,
        type: "rankings",
      },
      {
        willRender: dashboardWillRender
          ? toRender("Dashboard") !== undefined
          : false,
        props: { to: "/dashboard", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "dashboard").navitem_label ||
          t("gamification2026.navbar.dashboard"),
        order: this.customNavbar(campaign, "dashboard").navitem_order || 100007,
        type: "dashboard",
      },
      {
        willRender: true,
        props: { to: "/catalog", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "prize_store").navitem_label ||
          t("gamification2026.navbar.prize-store"),
        order:
          this.customNavbar(campaign, "prize_store").navitem_order || 10005,
        type: "prize_store",
      },
      {
        willRender:
          showAcceleratorsTab && toRender("Accelerators") !== undefined,
        props: { to: "/accelerators", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "accelerators").navitem_label ||
          t("gamification2026.navbar.campaigns"),
        order:
          this.customNavbar(campaign, "accelerators").navitem_order || 100006,
        type: "accelerators",
      },
      {
        willRender: toRender("SupportDocuments") !== undefined,
        props: { to: "/supporting-documents", onClick: this.hideMenu },
        text:
          this.customNavbar(campaign, "supporting-documents").navitem_label ||
          t("gamification2026.navbar.documents"),
        order:
          this.customNavbar(campaign, "supporting-documents").navitem_order ||
          100008,
        type: "supporting-documents",
      },
    ];
    return defaultNavbar;
  };

  separatePages() {
    const { pages } = this.props;
    let customPagesOnNavbar = [];
    let customPagesOnDropdown = [];
    pages.forEach((page) => {
      if (page.show_on_navbar) {
        customPagesOnNavbar.push(page);
      } else {
        customPagesOnDropdown.push(page);
      }
    });
    return {
      customPagesOnNavbar: customPagesOnNavbar,
      customPagesOnDropdown: customPagesOnDropdown,
    };
  }

  // Campaign selection
  selectCampaign = (campaign) => {
    return () => {
      this.handleCampaignSelection(campaign);
    };
  };

  handleCampaignSelection = (campaign) => {
    if (campaign.slug !== this.props.campaign.slug) {
      ReactGA.event({
        category: "Campaign change",
        action: "Selected - " + campaign.name,
      });
      localStorage.setItem("campaign", JSON.stringify(campaign));
      this.props.selectCampaign(campaign);
      this.props.history.push("/");
    }
  };

  render() {
    const {
      links,
      logo,
      itemCount,
      campaignUser,
      campaign,
      campaigns,
      toRender,
    } = this.props;
    const { toggled, Component, ButtonComponent } = this.state;
    const hasNotifications = itemCount > 0;

    const { customPagesOnNavbar, customPagesOnDropdown } = this.separatePages();

    let customNavbar = this.customizeNavBar();
    customNavbar = customNavbar.sort(function(a, b) {
      return a.order - b.order;
    });
    return (
      <div className="gl-navbar-wrapper">
        <div className="gl-navbar-links">
          <div className="gl-navbar-links__inner">
            {toRender("HeaderLinks") && links.length !== 0 && (
              <HeadersSection links={links} />
            )}
          </div>
        </div>
        <nav id="g-navbar" className="gl-navbar header-bg">
          <div className="gl-navbar-header">
            <div className="gl-navbar-header__logo">
              <Link
                onClick={this.hideMenu}
                exact
                to="/"
                className="gl-above-content content gl-navbar__logo-container"
              >
                <img src={logo.url} alt="logo" className="gl-navbar__logo" />
              </Link>

              <KeyDropdownValue
                name={`nav-dropdown-campaigns`}
                classNames="campaign-selector"
                disabled={!campaigns.length}
                options={campaigns}
                optionsLabel="name"
                optionsId="slug"
                selectedValue={campaign}
                onChange={this.handleCampaignSelection}
                placeholder="Selecione"
                noMessage={"Sem campanhas"}
                rightIcon={<ChevronDown />}
              ></KeyDropdownValue>

              <div className="user-section">
                <NotificationList />
                <Link
                  onClick={this.hideMenu}
                  to="/cart"
                  className="navbar-text gl-notification__container campaign-link-icon"
                >
                  <ShoppingCartIcon className="gl-navbar__icons24 mb-3 campaign-link-icon__stroke" />
                  {hasNotifications && <Counter brand value={itemCount} />}
                </Link>
                <Dropdown
                  onLogout={this.handleLogout}
                  campaignUser={campaignUser}
                  toRender={toRender}
                  customPages={customPagesOnDropdown}
                />
                <UserBadge />
              </div>
              <Burger open={toggled} onClick={toggled ? this.hideMenu : this.showMenu} />
            </div>
            {/* Desktop nav-links row — hidden at <740px via CSS */}
            <div className="gl-navbar-header__menu">
              <div
                id="nav"
                className="gl-nav navbar-text z-2 gl-navbar__links "
              >
                {customNavbar.map((navBar, i) => {
                  if (navBar["willRender"]) {
                    if (navBar["type"] == "supporting-documents") {
                      if (toRender("Pages") || toRender("SupportDocuments")) {
                        return (
                          <SimpleDropdown
                            key={"nav-dropdown-" + navBar.type + "-" + i}
                            condition={1 == 1}
                            message={navBar.text}
                            campaign={campaign}
                          >
                            <div className="flex flex-col">
                              {toRender("SupportDocuments") && (
                                <Component
                                  to="/supporting-documents/1"
                                  onClick={this.hideMenu}
                                  className="gl-mobile-show "
                                >
                                  {t("gamification2026.navbar.support-documents")}
                                </Component>
                              )}
                              {toRender("Pages") &&
                                customPagesOnDropdown.map((page) => {
                                  return (
                                    <Component
                                      key={page.slug}
                                      to={"/customized_pages/" + page.slug}
                                      onClick={this.hideMenu}
                                      className="gl-mobile-show "
                                    >
                                      {substring(page.title, 11, "..")}
                                    </Component>
                                  );
                                })}
                            </div>
                          </SimpleDropdown>
                        );
                      }
                    } else {
                      return (
                        <Component {...navBar.props} key={i}>
                          {navBar.text}
                        </Component>
                      );
                    }
                  }
                })}

                {customPagesOnNavbar.map((customPage, i) => {
                  return (
                    <Component
                      key={i}
                      to={"/customized_pages/" + customPage.slug}
                      onClick={this.hideMenu}
                    >
                      {customPage.title}
                    </Component>
                  );
                })}
              </div>
            </div>
          </div>
        </nav>

        {/* ── Mobile drawer — sibling of #g-navbar so #g-navbar rules cannot override it ── */}
        {toggled && (
          <div className="gl-drawer-overlay" onClick={this.hideMenu} aria-hidden="true" />
        )}
        <div className={"gl-drawer" + (toggled ? " gl-drawer--open" : "")} aria-hidden={!toggled}>
          <div className="gl-drawer__header">
            <Link to="/" onClick={this.hideMenu} className="gl-drawer__logo-link">
              <img src={logo.url} alt="logo" className="gl-drawer__logo" />
            </Link>
            <button
              type="button"
              className="gl-outline-reset gl-drawer__close"
              aria-label="Fechar menu"
              onClick={this.hideMenu}
            >
              <CloseMD />
            </button>
          </div>

          <div className="gl-drawer__badge">
            <UserBadge />
          </div>

          <div className="gl-drawer__body">
            {customNavbar.map((navBar, i) => {
              if (navBar["willRender"]) {
                if (navBar["type"] == "supporting-documents") {
                  if (toRender("Pages") || toRender("SupportDocuments")) {
                    return (
                      <SimpleDropdown
                        key={"drawer-dropdown-" + navBar.type + "-" + i}
                        condition={1 == 1}
                        message={navBar.text}
                        campaign={campaign}
                      >
                        <div className="flex flex-col">
                          {toRender("SupportDocuments") && (
                            <Link
                              to="/supporting-documents/1"
                              onClick={this.hideMenu}
                              className="gl-drawer__sub-item"
                              activeClassName="gl-drawer__item--active"
                            >
                              {t("gamification2026.navbar.support-documents")}
                            </Link>
                          )}
                          {toRender("Pages") &&
                            customPagesOnDropdown.map((page) => {
                              return (
                                <Link
                                  key={page.slug}
                                  to={"/customized_pages/" + page.slug}
                                  onClick={this.hideMenu}
                                  className="gl-drawer__sub-item"
                                  activeClassName="gl-drawer__item--active"
                                >
                                  {substring(page.title, 11, "..")}
                                </Link>
                              );
                            })}
                        </div>
                      </SimpleDropdown>
                    );
                  }
                } else {
                  return (
                    <Link
                      key={i}
                      to={navBar.props.to}
                      exact={navBar.props.exact}
                      onClick={this.hideMenu}
                      className="gl-drawer__item"
                      activeClassName="gl-drawer__item--active"
                    >
                      {navBar.text}
                    </Link>
                  );
                }
              }
            })}

            {customPagesOnNavbar.map((customPage, i) => {
              return (
                <Link
                  key={i}
                  to={"/customized_pages/" + customPage.slug}
                  onClick={this.hideMenu}
                  className="gl-drawer__item"
                  activeClassName="gl-drawer__item--active"
                >
                  {customPage.title}
                </Link>
              );
            })}

            {/* ── Management items (mirrors ElipsisDropdown desktop items) ── */}
            {campaignUser.canSeeAnalytics && (
              <Link
                to="/analytics"
                onClick={this.hideMenu}
                className="gl-drawer__item"
                activeClassName="gl-drawer__item--active"
              >
                {t("gamification2026.navbar.dashboard")}
              </Link>
            )}
            {toRender("Pontos Bonus") && campaignUser.canGiveBonusPoints && (
              <Link
                to="/bonus_points"
                onClick={this.hideMenu}
                className="gl-drawer__item"
                activeClassName="gl-drawer__item--active"
              >
                {t("gamification2026.navbar.bonus-points")}
              </Link>
            )}
            {toRender("Troca de Vendas") && (
              <Link
                to="/sale-trading/requested"
                onClick={this.hideMenu}
                className="gl-drawer__item"
                activeClassName="gl-drawer__item--active"
              >
                {t("gamification2026.navbar.sale-trading")}
              </Link>
            )}
            {toRender("Atribuição de Contratos") && campaignUser.canSeeSaleAttributions && (
              <Link
                to="/sale-attributions/pending"
                onClick={this.hideMenu}
                className="gl-drawer__item"
                activeClassName="gl-drawer__item--active"
              >
                {t("gamification2026.navbar.sale-attributions")}
              </Link>
            )}
          </div>

          <div className="gl-drawer__footer">
            <button className="gl-drawer__logout" onClick={this.handleLogout}>
              <User01  />
              {t("gamification2026.navbar.logout")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    saveLinks: (links) => {
      dispatch(saveLinks(links));
    },
    selectCampaign: (campaign) => {
      dispatch(selectCampaign(campaign));
    },
    doLogOut: () => {
      dispatch(doLogout());
    },
    startFetch: () => {
      dispatch(startFetch());
    },
    endFetch: () => {
      dispatch(endFetch());
    },
  };
}

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  itemCount: state.cartReducer.cart.items.length,
  campaignUser: state.balanceReducer.campaignUser,
  campaign: state.campaignReducer.campaign,
  campaigns: state.campaignReducer.campaigns,
  links: state.contentReducer.links,
  pages: state.pagesReducer.pages,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar));
